import type {WidgetType} from "constants/WidgetConstants";
import * as React from "react";
import type {WidgetProps, WidgetState} from "widgets/BaseWidget";
import TaroWidget from "widgetsTaro";
import {ValidationTypes} from "constants/WidgetValidation";
import type {Stylesheet} from "entities/AppTheming";
import {DefaultAutocompleteDefinitions} from "widgets/WidgetUtils";
import type {AutocompletionDefinitions} from "widgets/constants";
import TTextAreaNumberWidget from "../component";
import {DerivedPropertiesMap} from "../../../utils/WidgetFactory";
import {fontSizeOptions} from "../../../pages/Editor/ThemePropertyPane/controls/ThemeFormControl";
import {FontStyleTypes} from "constants/WidgetConstants";
import {isAutoLayout} from "../../../utils/autoLayout/flexWidgetUtils";
import {LabelPosition} from "../../../components/constants";
import {Alignment} from "@blueprintjs/core";
import type {BaseInputWidgetProps} from "../../../widgets/BaseInputWidget/widget";
import contentConfig from "./contentConfig";
import styleConfig from "./styleConfig";

class TTextAreaNumber extends TaroWidget<TTextAreaNumberWidgetProps, WidgetState> {
  constructor(props: TTextAreaNumberWidgetProps) {
    super(props);
  }
  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return {
      value: "string",
      isVisible: DefaultAutocompleteDefinitions.isVisible,
    };
  }

  static getPropertyPaneContentConfig = contentConfig;
  static getPropertyPaneStyleConfig = styleConfig;

  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {
      getValue: `{{ this.value }}`,
      isValid: `{{ this.isRequired ? !!this.value : true }}`
    };
  }
  static getDefaultPropertiesMap(): Record<string, string> {
    return {
      value: "defaultValue"
    };
  }
  static getStylesheetConfig(): Stylesheet {
    return {
      borderRadius: "{{appsmith.theme.borderRadius.appBorderRadius}}",
      boxShadow: "none",
      fontSize: "{{appsmith.theme.form.label.fontSize}}",
      color: "{{appsmith.theme.form.label.fontColor}}",
      fontStyle: "{{appsmith.theme.form.label.fontStyle}}",
      inputFontSize: "{{appsmith.theme.form.inputText.fontSize}}",
      inputColor: "{{appsmith.theme.form.inputText.fontColor}}",
      inputFontStyle: "{{appsmith.theme.form.inputText.fontStyle}}",
      bgColor: "{{appsmith.theme.form.inputBorder.bgColor}}",
      borderColor: "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
    };
  }
  updateWidgetProperty = (propertyValues: string) => {
    if (!this.props.isDirty) {
      this.props.updateWidgetMetaProperty("isDirty", true);
    }
    this.props.updateWidgetMetaProperty("value", propertyValues);
  }

  getPageView() {
    return (
      <TTextAreaNumberWidget {...this.props} updateWidgetProperty={this.updateWidgetProperty} />
    );
  }


  static getWidgetType(): WidgetType {
    return "AT_TEXTAREA_WIDGET";
  }
}

export interface TTextAreaNumberWidgetProps extends WidgetProps {
  value: any[];
  label: string;
  onClick?: any;
  borderRadius: string;
  boxShadow?: string;
}

export default TTextAreaNumber;
